import * as React from 'react';
import { OptionsType, ValueType } from 'react-select/src/types';
import {
  DARK_PLACEHOLDER,
  getAlphaComparator,
  getNewValue,
  stringToOptions,
} from '../../../../constants';
import COUNTRIES from '../../../../countries.json';
import InputDropdown from '../../../../widgets/InputDropdown';
import { FilterDropdownProps } from './AdditionalFilterBar';
import { OptionType } from '../../../../types';

const COUNTRY_LIST: OptionsType<OptionType> = [
  { value: '_interesting', label: '"Interesting"' },
  { value: '_unknown', label: '"Unknown"' },
].concat(
  COUNTRIES.map((country) => ({
    value: country.value,
    label: country.description,
  })).sort(getAlphaComparator('label')),
);

export default class LocationFilterDropdown extends React.Component<FilterDropdownProps> {
  handleSelectChange = (value: ValueType<OptionType>) => {
    const v = getNewValue(value, true);
    this.props.setFilter(
      this.props.filterKey,
      v && v.map((sel) => sel.value).join(','),
    );
  };

  render() {
    const value = this.props.value || '';

    // Use a custom react-select renderer to highlight individual interesting countries in the <Select> list?
    return (
      <div className="pr-3 pt-3" style={{ minWidth: '195px' }}>
        <h5>Location</h5>

        <InputDropdown
          isMulti={true}
          onChange={this.handleSelectChange}
          options={COUNTRY_LIST}
          placeholder="All locations"
          value={stringToOptions(value, COUNTRY_LIST)}
          styles={DARK_PLACEHOLDER}
        />
      </div>
    );
  }
}
